/**
 * Gevelcalculator Compolux Highline — UI, winkelwagen en meting.
 *
 * Het rekenwerk zit in adeqo-gevelcalculator-core.js en is daar getest tegen de
 * gepubliceerde referentiecases. Dit bestand doet alleen DOM, prijzen en events.
 *
 * Prijzen: uitsluitend uit de catalogus die Liquid meestuurt (live uit Shopify).
 * Staat een artikel niet in die catalogus, dan is het uitverkocht, staat het op
 * concept of bestaat het nog niet. Zo'n regel toont "niet leverbaar", telt niet
 * mee in het totaal en gaat nooit de winkelwagen in.
 *
 * De klassenamen zeggen nog "opaanvraag". Die naam stamt uit de tijd dat het
 * montagesysteem alleen op offerte ging; de melding zelf verwijst bewust niet
 * meer naar de contactpagina, want een ontbrekend artikel is nu een voorraad-
 * kwestie en geen aanvraag.
 */
(function () {
  'use strict';

  // i18n-bridge: strings, taal en valuta komen uit window.theme (gezet door
  // snippets/theme-i18n-strings.liquid in de <head>). Valt terug op NL zodat de
  // calculator ook zonder bridge blijft rekenen en leesbaar blijft.
  var t = (window.theme && window.theme.t) || function (k, f) { return f || ''; };
  var LOCALE = (window.theme && window.theme.locale) || 'nl-NL';
  var VALUTA = (window.theme && window.theme.currency) || 'EUR';

  /** Vult {naam}-plaatshouders in een vertaalde string. */
  function vul(str, waarden) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(waarden, k) ? waarden[k] : m;
    });
  }

  var euro = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: VALUTA });
  var euroRond = new Intl.NumberFormat(LOCALE, {
    style: 'currency', currency: VALUTA, minimumFractionDigits: 0, maximumFractionDigits: 0
  });
  /** Winkelformaat (shop.money_format) via de i18n-bridge, gelijk aan de Liquid-prijzen; Intl als vangnet. */
  function geld(centen) {
    if (window.theme && window.theme.money) return window.theme.money(centen);
    return euro.format(centen / 100);
  }
  /** Ronde bedragen zonder ",00": "gratis verzending vanaf €1.500" leest prettiger. */
  function geldKort(centen) {
    if (window.theme && window.theme.money) {
      var s = window.theme.money(centen);
      return centen % 100 === 0 ? s.replace(/[.,]00(?!\d)/, '') : s;
    }
    return (centen % 100 === 0 ? euroRond : euro).format(centen / 100);
  }

  /** "a, b en c" — een opsomming met komma's en één voegwoord aan het eind. */
  function opsomming(lijst) {
    if (lijst.length < 2) return lijst[0] || '';
    return lijst.slice(0, -1).join(', ') + ' ' + t('gc_list_and', 'en') + ' ' + lijst[lijst.length - 1];
  }
  function getal(n, dec) {
    return new Intl.NumberFormat(LOCALE, {
      minimumFractionDigits: dec || 0, maximumFractionDigits: dec || 0
    }).format(n);
  }

  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  var teller = 0;

  function init(root) {
    if (root.dataset.gcInit) return;
    root.dataset.gcInit = '1';

    var core = window.AdeqoGevelCore;
    if (!core) return;

    // Twee calculators op één pagina zouden in elkaars radiogroep vallen: het
    // token kan meer dan eens in een artikel staan. De oorspronkelijke naam
    // blijft als data-attribuut staan, want daar zoeken we hieronder op.
    var uid = ++teller;
    root.querySelectorAll('input[type="radio"][name]').forEach(function (radio) {
      if (radio.dataset.gcGroep) return;
      radio.dataset.gcGroep = radio.name;
      radio.name = radio.name + '-' + uid;
    });

    var catalogusEl = root.querySelector('[data-gc-catalogus]');
    var configEl = root.querySelector('[data-gc-config]');
    var catalogus = catalogusEl ? (json(catalogusEl) || {}) : {};
    var config = configEl ? (json(configEl) || {}) : {};
    // Zakelijke klant: geen bedragen, want die rekenen met de consumentenprijs.
    // De Liquid laat de bedragkolom en het totaal dan weg.
    var zakelijk = config.zakelijk === true;

    var els = {
      vlakken: root.querySelector('[data-gc-vlakken]'),
      toevoegen: root.querySelector('[data-gc-vlak-toevoegen]'),
      hoeken: root.querySelector('[data-gc-hoeken]'),
      eind: root.querySelector('[data-gc-eind]'),
      samenvatting: root.querySelector('[data-gc-samenvatting]'),
      regels: root.querySelector('[data-gc-regels]'),
      totaal: root.querySelector('[data-gc-totaal]'),
      opaanvraag: root.querySelector('[data-gc-opaanvraag]'),
      bestel: root.querySelector('[data-gc-bestel]'),
      status: root.querySelector('[data-gc-status]'),
      uitleg: root.querySelector('[data-gc-uitleg]'),
      lengteAdvies: root.querySelector('[data-gc-lengte-advies]'),
      drempel: root.querySelector('[data-gc-drempel]'),
      // Alleen in blogmodus: het antwoord boven de uitklap.
      kort: root.querySelector('[data-gc-kort]')
    };

    if (els.drempel) els.drempel.textContent = geldKort(config.verzenddrempel || 150000);

    // Eén vlak vooringevuld met een alledaagse aanbouwmaat, zodat de bezoeker
    // meteen ziet wat het ding doet in plaats van naar nullen te kijken.
    var vlakken = [{ breedte: '6', hoogte: '2.5', openingen: [] }];
    var laatste = null;

    // ---------------------------------------------------------------- invoer
    function tekenVlakken() {
      els.vlakken.innerHTML = '';
      vlakken.forEach(function (vlak, i) {
        var rij = document.createElement('div');
        rij.className = 'gevelcalc__vlak';
        rij.innerHTML =
          '<div class="gevelcalc__vlak-kop">' +
            '<span class="gevelcalc__vlak-naam">' + vul(t('gc_area_label', 'Vlak {n}'), { n: i + 1 }) + '</span>' +
            (vlakken.length > 1
              ? '<button type="button" class="gevelcalc__verwijder" data-gc-vlak-weg="' + i + '" aria-label="' + vul(t('gc_area_remove_aria', 'Vlak {n} verwijderen'), { n: i + 1 }) + '">' + t('gc_remove', 'Verwijderen') + '</button>'
              : '') +
          '</div>' +
          '<div class="gevelcalc__duo">' +
            '<label class="gevelcalc__veld"><span class="gevelcalc__label">' + t('gc_width', 'Breedte') + '</span>' +
              '<input type="number" min="0" step="0.01" inputmode="decimal" value="' + vlak.breedte + '" data-gc-breedte="' + i + '">' +
              '<span class="gevelcalc__unit">m</span></label>' +
            '<label class="gevelcalc__veld"><span class="gevelcalc__label">' + t('gc_height', 'Hoogte') + '</span>' +
              '<input type="number" min="0" step="0.01" inputmode="decimal" value="' + vlak.hoogte + '" data-gc-hoogte="' + i + '">' +
              '<span class="gevelcalc__unit">m</span></label>' +
          '</div>' +
          '<div class="gevelcalc__openingen" data-gc-openingen="' + i + '"></div>' +
          '<button type="button" class="gevelcalc__btn-mini" data-gc-opening-toevoegen="' + i + '">' +
            '<span aria-hidden="true">+</span> ' + t('gc_add_opening', 'Kozijn of deur') +
          '</button>';
        els.vlakken.appendChild(rij);

        var houder = rij.querySelector('[data-gc-openingen="' + i + '"]');
        vlak.openingen.forEach(function (o, j) {
          var op = document.createElement('div');
          op.className = 'gevelcalc__opening';
          op.innerHTML =
            '<label class="gevelcalc__veld gevelcalc__veld--mini"><span class="gevelcalc__label">' + t('gc_qty', 'Aantal') + '</span>' +
              '<input type="number" min="1" step="1" inputmode="numeric" value="' + o.aantal + '" data-gc-o-aantal="' + i + '.' + j + '"></label>' +
            '<label class="gevelcalc__veld gevelcalc__veld--mini"><span class="gevelcalc__label">' + t('gc_width', 'Breedte') + '</span>' +
              '<input type="number" min="0" step="0.01" inputmode="decimal" value="' + o.breedte + '" data-gc-o-breedte="' + i + '.' + j + '"><span class="gevelcalc__unit">m</span></label>' +
            '<label class="gevelcalc__veld gevelcalc__veld--mini"><span class="gevelcalc__label">' + t('gc_height', 'Hoogte') + '</span>' +
              '<input type="number" min="0" step="0.01" inputmode="decimal" value="' + o.hoogte + '" data-gc-o-hoogte="' + i + '.' + j + '"><span class="gevelcalc__unit">m</span></label>' +
            '<button type="button" class="gevelcalc__verwijder gevelcalc__verwijder--mini" data-gc-opening-weg="' + i + '.' + j + '" aria-label="' + t('gc_opening_remove_aria', 'Opening verwijderen') + '">' + t('gc_remove_short', 'Weg') + '</button>';
          houder.appendChild(op);
        });
      });
    }

    function leesInvoer() {
      return {
        vlakken: vlakken.map(function (v) {
          return {
            breedte: v.breedte, hoogte: v.hoogte,
            openingen: v.openingen.map(function (o) {
              return { aantal: o.aantal, breedte: o.breedte, hoogte: o.hoogte };
            })
          };
        }),
        paneellengte: (root.querySelector('[data-gc-groep="gc-lengte"]:checked') || {}).value || 'advies',
        kleur: (root.querySelector('[data-gc-groep="gc-kleur"]:checked') || {}).value || 'eiken',
        buitenhoeken: els.hoeken.value,
        eindafwerkingen: els.eind.value
      };
    }

    // -------------------------------------------------------------- catalogus
    function zoek(handle) {
      var p = catalogus[handle];
      return p && p.beschikbaar ? p : null;
    }

    /* De verpakkingsgrootte staat op één plek: CONSTANTS.VERPAKKING in de
       rekenkern. Het label leidt daarvan af, zodat "3 x verpakking van 50" nooit
       kan gaan afwijken van het aantal waar de kern mee deelt. Bevestigt de
       leverancier een andere zakinhoud, dan is die ene constante de enige plek
       in de code die mee moet. De producttitel in Shopify noemt het aantal ook,
       en die moet apart worden bijgewerkt. */
    function perVerpakking(sleutel, woord) {
      var C = core.CONSTANTS && core.CONSTANTS.VERPAKKING;
      var n = C && C[sleutel];
      var eenheid = woord || t('gc_unit_pack', 'verpakking');
      return n ? vul(t('gc_unit_pack_of', '{unit} van {n}'), { unit: eenheid, n: n }) : eenheid;
    }

    /** Bouwt de stuklijst: elke regel weet of hij bestelbaar is of niet. */
    function bouwRegels(r) {
      var kleur = r.invoer.kleur, lengte = r.invoer.paneellengte;
      var Kleur = kleur.charAt(0).toUpperCase() + kleur.slice(1);
      // Hoek- en eindprofiel bestaan alleen in 3,5 m (Compolux, 14-08-2026); de
      // zes 300 cm-varianten staan sindsdien op draft. Profielen worden op maat
      // gezaagd, dus de gekozen paneellengte doet hier niet ter zake. Leidde je
      // de handle wel af uit de paneellengte, dan zocht de stuklijst bij een
      // advies van 300 cm een product dat niet bestaat en viel de regel terug
      // op "niet leverbaar" - precies bij de lengte die de kern meestal kiest.
      var profiellengte = 350;
      var rijen = [
        { sleutel: 'panelen', label: 'Compolux Highline ' + Kleur + ' ' + lengte + ' cm',
          handle: 'composiet-gevelbekleding-' + kleur + '-' + lengte + '-cm',
          aantal: r.stuks.panelen, eenheid: t('gc_unit_panel', 'paneel') },
        { sleutel: 'hoekprofielen', label: 'Hoekprofiel ' + Kleur + ' ' + profiellengte + ' cm',
          handle: 'hoekprofiel-composiet-gevelbekleding-' + kleur + '-' + profiellengte + '-cm',
          aantal: r.stuks.hoekprofielen, eenheid: t('gc_unit_profile', 'profiel') },
        { sleutel: 'eindprofielen', label: 'Eindprofiel ' + Kleur + ' ' + profiellengte + ' cm',
          handle: 'eindprofiel-composiet-gevelbekleding-' + kleur + '-' + profiellengte + '-cm',
          aantal: r.stuks.eindprofielen, eenheid: t('gc_unit_profile', 'profiel') },
        { sleutel: 'onderbalken', label: 'Aluminium onderbalk 280 cm',
          handle: 'aluminium-onderbalk-composiet-gevelbekleding',
          aantal: r.stuks.onderbalken, eenheid: t('gc_unit_beam', 'balk') },
        { sleutel: 'montageclips', label: 'Montageclips',
          handle: 'montageclips-composiet-gevelbekleding',
          aantal: r.verpakkingen.montageclips, eenheid: perVerpakking('montageclips'),
          stuks: r.stuks.montageclips },
        { sleutel: 'startclips', label: 'Startclips',
          handle: 'startclips-composiet-gevelbekleding',
          aantal: r.verpakkingen.startclips, eenheid: perVerpakking('startclips'),
          stuks: r.stuks.startclips }
      ];

      return rijen.filter(function (rij) { return rij.aantal > 0; })
        .map(function (rij) {
          var p = zoek(rij.handle);
          rij.product = p;
          // De producttitel komt vertaald uit Shopify mee in de catalogus; het
          // samengestelde label hierboven is alleen de terugval voor een artikel
          // dat niet (meer) in de collectie zit.
          if (p && p.titel) rij.label = p.titel;
          rij.bestelbaar = !!p;
          rij.regeltotaal = p ? p.prijs * rij.aantal : 0;
          return rij;
        });
    }

    // ------------------------------------------------------- kort antwoord
    /** Paneelprijs in centen, of 0 als het artikel niet leverbaar is. */
    function paneelprijs(kleur, lengte) {
      var p = zoek('composiet-gevelbekleding-' + kleur + '-' + lengte + '-cm');
      return p ? p.prijs : 0;
    }

    /**
     * Het antwoord boven de uitklap in blogmodus: hoeveel panelen, wat kosten
     * die, en wat de andere lengte zou doen.
     *
     * DIT IS PRESENTATIE, GEEN TWEEDE BEREKENING. Het leest hetzelfde resultaat
     * dat de kaart eronder gebruikt en roept de kern nog één keer aan voor de
     * andere paneellengte, puur om de keuze navolgbaar te maken. Er staat hier
     * geen zaagverlies, geen paneeloppervlak en geen afronding: die horen in
     * adeqo-gevelcalculator-core.js en nergens anders.
     */
    function tekenKort(r, invoer) {
      if (!els.kort) return;

      if (!r) {
        els.kort.innerHTML = '<p class="gcb__leeg">' + t('gc_empty_short', 'Vul de breedte en de hoogte in.') + '</p>';
        return;
      }

      var lengte = r.invoer.paneellengte;
      var kleur = r.invoer.kleur;
      var prijs = paneelprijs(kleur, lengte);

      var html =
        '<p class="gcb__getal">' +
        vul(t('gc_panels_of_html', '<strong>{count}</strong> panelen van {length} cm'),
            { count: getal(r.stuks.panelen), length: lengte }) +
        (r.invoer.paneellengteGeadviseerd ? '<span class="gcb__advies">' + t('gc_advice_badge', 'advies') + '</span>' : '') +
        '</p>';

      // BEWUST GEEN TOTAALBEDRAG HIER (keuze van Sam, 12-08). Een bedrag van
      // ruim duizend euro halverwege een artikel schrikt af, en het zou boven-
      // dien een onvolledig beeld geven: het dekt alleen de panelen, niet de
      // onderbalken, profielen en clips die er ook bij horen. Wie het complete
      // bedrag wil, vindt de stuklijst met totaal achter de uitklap. Het prijs-
      // VERSCHIL tussen de twee lengtes blijft wel staan, want dat verklaart
      // waarom de ene lengte geadviseerd wordt en de andere niet.

      html += '<p class="gcb__stap">' +
        vul(t('gc_step_waste', '{netto} m² plus {pct}% zaagverlies is {bruto} m²'), {
          netto: getal(r.oppervlak.netto, 1),
          pct: Math.round((r.oppervlak.zaagverliesFactor - 1) * 100),
          bruto: getal(r.oppervlak.inclusiefZaagverlies, 1)
        }) + '</p>';

      var andere = lengte === 350 ? 300 : 350;
      var rAnder = core.bereken({
        vlakken: invoer.vlakken,
        paneellengte: andere,
        kleur: invoer.kleur,
        buitenhoeken: invoer.buitenhoeken,
        eindafwerkingen: invoer.eindafwerkingen
      });

      if (rAnder) {
        var zin = vul(t('gc_compare', 'Met panelen van {length} cm: {count} stuks'),
                      { length: andere, count: getal(rAnder.stuks.panelen) });
        var prijsAnder = paneelprijs(kleur, andere);
        if (!zakelijk && prijs > 0 && prijsAnder > 0) {
          var verschil = (prijsAnder * rAnder.stuks.panelen) - (prijs * r.stuks.panelen);
          if (verschil > 0) zin += ', ' + vul(t('gc_compare_more', '{amount} duurder'), { amount: geld(verschil) });
          else if (verschil < 0) zin += ', ' + vul(t('gc_compare_less', '{amount} goedkoper'), { amount: geld(-verschil) });
          else zin += ', ' + t('gc_compare_same', 'hetzelfde bedrag');
        }
        html += '<p class="gcb__vergelijk">' + zin + '.</p>';
      }

      els.kort.innerHTML = html;
    }

    // ----------------------------------------------------------------- render
    function teken() {
      var invoer = leesInvoer();
      var r = core.bereken(invoer);
      laatste = null;

      if (!r) {
        els.samenvatting.innerHTML = '<p class="gevelcalc__leeg">' + t('gc_empty_full', 'Vul de breedte en hoogte van minstens één vlak in.') + '</p>';
        els.regels.innerHTML = '';
        if (els.totaal) els.totaal.textContent = '—';
        els.opaanvraag.hidden = true;
        els.bestel.disabled = true;
        if (els.lengteAdvies) els.lengteAdvies.textContent = '';
        if (els.uitleg) els.uitleg.innerHTML = '';
        tekenKort(null, invoer);
        return;
      }

      tekenKort(r, invoer);

      var regels = bouwRegels(r);
      laatste = { resultaat: r, regels: regels };

      els.samenvatting.innerHTML =
        '<div class="gevelcalc__kop-getal">' +
        vul(t('gc_panels_of_html', '<strong>{count}</strong> panelen van {length} cm'),
            { count: getal(r.stuks.panelen), length: r.invoer.paneellengte }) + '</div>' +
        '<div class="gevelcalc__kop-sub">' +
        vul(t('gc_summary_sub', '{netto} m² netto, {bruto} m² inclusief {pct}% zaagverlies'), {
          netto: getal(r.oppervlak.netto, 1),
          bruto: getal(r.oppervlak.inclusiefZaagverlies, 1),
          pct: Math.round((r.oppervlak.zaagverliesFactor - 1) * 100)
        }) + '</div>';

      if (els.lengteAdvies) {
        els.lengteAdvies.textContent = r.invoer.paneellengteGeadviseerd
          ? vul(t('gc_length_advice', 'Bij deze maten adviseren wij {length} cm.'), { length: r.invoer.paneellengte })
          : '';
      }

      var totaal = 0, nietBestelbaar = [];
      els.regels.innerHTML = '';
      regels.forEach(function (rij) {
        var tr = document.createElement('tr');
        var aantalTekst = getal(rij.aantal) + ' × ' + rij.eenheid;
        var detail = rij.stuks ? '<span class="gevelcalc__detail">' + vul(t('gc_pieces_needed', '{count} stuks nodig'), { count: getal(rij.stuks) }) + '</span>' : '';

        var badge = '<span class="gevelcalc__badge">' + t('gc_not_available', 'niet leverbaar') + '</span>';

        if (rij.bestelbaar) {
          totaal += rij.regeltotaal;
          tr.innerHTML = zakelijk
            ? '<td><a href="' + rij.product.url + '">' + rij.label + '</a>' + detail + '</td>' +
              '<td class="gevelcalc__num">' + aantalTekst + '</td>'
            : '<td><a href="' + rij.product.url + '">' + rij.label + '</a>' + detail +
                '<span class="gevelcalc__detail">' + vul(t('gc_per_piece', '{amount} per stuk'), { amount: geld(rij.product.prijs) }) + '</span></td>' +
              '<td class="gevelcalc__num">' + aantalTekst + '</td>' +
              '<td class="gevelcalc__num">' + geld(rij.regeltotaal) + '</td>';
        } else {
          nietBestelbaar.push(rij.label);
          tr.className = 'gevelcalc__rij--aanvraag';
          // Zonder bedragkolom staat het label achter de artikelnaam.
          tr.innerHTML = zakelijk
            ? '<td>' + rij.label + ' ' + badge + detail + '</td>' +
              '<td class="gevelcalc__num">' + aantalTekst + '</td>'
            : '<td>' + rij.label + detail + '</td>' +
              '<td class="gevelcalc__num">' + aantalTekst + '</td>' +
              '<td class="gevelcalc__num">' + badge + '</td>';
        }
        els.regels.appendChild(tr);
      });

      if (els.totaal) els.totaal.textContent = geld(totaal);
      laatste.totaal = totaal;

      if (nietBestelbaar.length) {
        els.opaanvraag.hidden = false;
        els.opaanvraag.textContent = vul(
          nietBestelbaar.length > 1
            ? t('gc_unavailable_many', '{items} zijn op dit moment niet leverbaar en tellen daarom niet mee in het totaal.')
            : t('gc_unavailable_one', '{items} is op dit moment niet leverbaar en telt daarom niet mee in het totaal.'),
          { items: opsomming(nietBestelbaar) }
        );
      } else {
        els.opaanvraag.hidden = true;
      }

      var bestelbaar = regels.filter(function (x) { return x.bestelbaar; });
      els.bestel.disabled = bestelbaar.length === 0;

      if (els.uitleg) {
        var uitlegUrl = (window.theme && window.theme.url)
          ? window.theme.url('/blogs/adeqo-blog/hoeveel-gevelbekleding-nodig')
          : '/blogs/adeqo-blog/hoeveel-gevelbekleding-nodig';
        els.uitleg.innerHTML =
          '<ol class="gevelcalc__stappen">' +
          '<li>' + vul(t('gc_explain_gross', 'Oppervlak van de vlakken: {value} m²'), { value: getal(r.oppervlak.bruto, 1) }) + '</li>' +
          '<li>' + vul(t('gc_explain_openings', 'Openingen eraf: {openings} m², netto {netto} m²'), {
            openings: getal(r.oppervlak.openingen, 1), netto: getal(r.oppervlak.netto, 1) }) + '</li>' +
          '<li>' + vul(t('gc_explain_waste', 'Zaagverlies erbij ({pct}%): {value} m²'), {
            pct: Math.round((r.oppervlak.zaagverliesFactor - 1) * 100), value: getal(r.oppervlak.inclusiefZaagverlies, 1) }) + '</li>' +
          '<li>' + vul(t('gc_explain_divide', 'Gedeeld door {m2} m² per paneel van {length} cm: {raw}, naar boven afgerond {count} panelen'), {
            m2: getal(r.paneelM2, 2), length: r.invoer.paneellengte,
            raw: getal(r.panelenRuw, 1), count: getal(r.stuks.panelen) }) + '</li>' +
          '<li>' + vul(t('gc_explain_rails', 'Regelwerk: {positions} verticale regels, samen {meters} meter, gedeeld door 2,8 m per balk is {count} onderbalken'), {
            positions: getal(r.posities), meters: getal(r.regelmeters, 1), count: getal(r.stuks.onderbalken) }) + '</li>' +
          '<li>' + vul(t('gc_explain_clips', 'Clips: {perPanel} montageclips per paneel, en 1 startclip per paneel plus 1 voor het eerste paneel'), {
            perPanel: getal(r.clipsPerPaneel) }) + '</li>' +
          '</ol>' +
          '<p class="gevelcalc__klein">' +
          vul(t('gc_explain_note_html', 'Wij rekenen met de werkende breedte van 20,25 cm, niet met de plankbreedte van 22,1 cm. Dat is dezelfde methode als in onze uitleg <a href="{url}">gevelbekleding berekenen</a>.'), { url: uitlegUrl }) +
          '</p>';
      }
    }

    // ------------------------------------------------------------- winkelwagen
    function bestel() {
      if (!laatste) return;
      var items = laatste.regels.filter(function (x) { return x.bestelbaar; })
        .map(function (x) { return { id: x.product.id, quantity: x.aantal }; });
      if (!items.length) return;

      els.bestel.disabled = true;
      els.status.textContent = t('gc_adding', 'Bezig met toevoegen…');

      var klaar = function (ok) {
        els.bestel.disabled = false;
        els.status.textContent = ok
          ? t('gc_added', 'Toegevoegd aan de winkelwagen.')
          : t('gc_add_failed', 'Toevoegen lukte niet. Probeer het opnieuw of neem contact met ons op.');
      };

      if (window.AdeqoCart && typeof window.AdeqoCart.add === 'function') {
        window.AdeqoCart.add(items, { source: 'gevelcalculator' })
          .then(function () { klaar(true); meet('bestellen'); })
          .catch(function () { klaar(false); });
      } else {
        fetch(window.theme && window.theme.routes ? window.theme.routes.cart_add + '.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart');
          klaar(true); meet('bestellen');
          document.dispatchEvent(new CustomEvent('adeqo:cart:add', {
            detail: { requested: items, source: 'gevelcalculator' }
          }));
        }).catch(function () { klaar(false); });
      }
    }

    // ------------------------------------------------------------------ meting
    // Gaat naar dezelfde first-party tap als theme-capture (go.adeqo.eu). De
    // consent-staat reist mee in de body zoals bij /c; het delen naar derden is
    // verderop in de pijplijn consent-gated. Geen contactgegevens, geen id's:
    // dit is een maatvoering-record, geen persoonsgegeven.
    //
    // LET OP — de router kent /e vandaag NOG NIET (geverifieerd 11-08-2026:
    // /ping geeft 204 vanaf adeqo.eu, /e geeft 404). De fetch faalt dus stil en
    // het record landt nergens. De calculator blijft daardoor gewoon werken; het
    // event 'adeqo:gevelberekening' vuurt hoe dan ook, zodat bestaande
    // listeners er nu al op kunnen aanhaken. Zodra de router een /e-handler
    // heeft die deze body wegschrijft, werkt de meting zonder themewijziging.
    var gemeten = {};
    function meet(actie) {
      if (!laatste) return;
      var r = laatste.resultaat;
      var sleutel = actie + '|' + r.oppervlak.netto.toFixed(2) + '|' + r.stuks.panelen;
      if (gemeten[sleutel]) return;
      gemeten[sleutel] = true;

      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var body = {
        _e: 'gevelberekening',
        actie: actie,
        bron: root.dataset.bron || 'onbekend',
        m2_netto: Number(r.oppervlak.netto.toFixed(2)),
        m2_bruto: Number(r.oppervlak.inclusiefZaagverlies.toFixed(2)),
        vlakken: r.invoer.vlakken,
        openingen: r.invoer.openingen,
        paneellengte: r.invoer.paneellengte,
        paneellengte_geadviseerd: r.invoer.paneellengteGeadviseerd,
        kleur: r.invoer.kleur,
        panelen: r.stuks.panelen,
        onderbalken: r.stuks.onderbalken,
        totaal_centen: laatste.totaal || 0,
        _cm: (cp && cp.marketingAllowed && cp.marketingAllowed()) ? 1 : 0,
        _ca: (cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()) ? 1 : 0
      };

      try {
        fetch('https://go.adeqo.eu/e', {
          method: 'POST', credentials: 'include', keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).catch(function () {});
      } catch (e) {}

      document.dispatchEvent(new CustomEvent('adeqo:gevelberekening', { detail: body }));
    }

    // -------------------------------------------------------------- luisteraars
    // Één gedelegeerde listener: de vlakken worden opnieuw getekend en
    // losse listeners zouden bij elke hertekening opnieuw moeten worden gezet.
    root.addEventListener('input', function (e) {
      var t = e.target;
      var d = t.dataset;
      if (d.gcBreedte !== undefined) vlakken[+d.gcBreedte].breedte = t.value;
      else if (d.gcHoogte !== undefined) vlakken[+d.gcHoogte].hoogte = t.value;
      else if (d.gcOAantal !== undefined) pak(d.gcOAantal).aantal = t.value;
      else if (d.gcOBreedte !== undefined) pak(d.gcOBreedte).breedte = t.value;
      else if (d.gcOHoogte !== undefined) pak(d.gcOHoogte).hoogte = t.value;
      teken();
    });

    root.addEventListener('change', function (e) {
      var groep = e.target.dataset && e.target.dataset.gcGroep;
      if (groep === 'gc-lengte' || groep === 'gc-kleur') teken();
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || !root.contains(btn)) return;
      var d = btn.dataset;

      if (d.gcVlakToevoegen !== undefined) {
        vlakken.push({ breedte: '', hoogte: '', openingen: [] });
        tekenVlakken(); teken();
      } else if (d.gcVlakWeg !== undefined) {
        vlakken.splice(+d.gcVlakWeg, 1);
        tekenVlakken(); teken();
      } else if (d.gcOpeningToevoegen !== undefined) {
        vlakken[+d.gcOpeningToevoegen].openingen.push({ aantal: '1', breedte: '', hoogte: '' });
        tekenVlakken(); teken();
      } else if (d.gcOpeningWeg !== undefined) {
        var p = d.gcOpeningWeg.split('.');
        vlakken[+p[0]].openingen.splice(+p[1], 1);
        tekenVlakken(); teken();
      } else if (d.gcBestel !== undefined) {
        bestel();
      }
    });


    function pak(pad) {
      var p = pad.split('.');
      return vlakken[+p[0]].openingen[+p[1]];
    }

    tekenVlakken();
    teken();
  }

  function start() {
    document.querySelectorAll('[data-gevelcalc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // De blogplaatsing en de landingssecties kunnen na de eerste render binnenkomen
  // (theme-editor, lazy secties). Opnieuw proberen is goedkoop: init is idempotent.
  document.addEventListener('shopify:section:load', start);
})();
